import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

export const PrivateRouter = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => {
  const { location } = rest;
  localStorage.setItem("lastPath", location.pathname);

  // Obtener el parámetro referral_code si existe
  const searchParams = new URLSearchParams(location.search);
  const referralCode = searchParams.get("referral_code");

  return (
    <Route
      {...rest}
      component={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={
              referralCode
                ? `/catalogo?referral_code=${referralCode}`
                : "/catalogo"
            }
          />
        )
      }
    />
  );
};

PrivateRouter.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
};
